import { MediaDrawer } from './MediaDrawer'
import { SelectMediaDrawerProps, SelectMediaProps, UploadedMediaCarouselProps } from '../Types'
import { MediaFileGrid } from './MediaFileGrid'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { BrandKit as BrandKitType } from 'types'

interface BrandKitDrawerProps extends SelectMediaDrawerProps, UploadedMediaCarouselProps {
  brandKit: BrandKitType
}

export const BrandKitDrawer = observer((props: BrandKitDrawerProps) => {
  const { accept, onSelect, brandKit, ...rest } = props
  const { closeDrawer } = useRootStore().drawersStore
  const mediaFiles = brandKit.media_files.filter((file) => accept.includes(file.mime_type))

  const handleSelect = ({ file, needsDownload }: SelectMediaProps) => {
    onSelect({ file, needsDownload, provider: 'brandKits' })
    closeDrawer()
  }

  return (
    <MediaDrawer {...rest}>
      <MediaFileGrid mediaFiles={mediaFiles} onSelect={handleSelect} />
    </MediaDrawer>
  )
})
